import TaTransaction from './TaTransaction'

export default TaTransaction
